/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 * @generated-id: 247c505056a9
 */

import * as z from "zod";
import { ApiError, ApiError$zodSchema } from "./apierror.js";
import { UsageResponse, UsageResponse$zodSchema } from "./usageresponse.js";

export type GetUsageGlobals = { cloud_name?: string | undefined };

export const GetUsageGlobals$zodSchema: z.ZodType<GetUsageGlobals> = z.object({
  cloud_name: z.string().describe("The cloud name of your product environment.")
    .optional(),
});

export type GetUsageRequest = { date?: string | undefined };

export const GetUsageRequest$zodSchema: z.ZodType<GetUsageRequest> = z.object({
  date: z.string().date().describe(
    "The date for which to retrieve usage details (YYYY-MM-DD). If not specified, returns the current usage.",
  ).optional(),
});

export type GetUsageResponse = ApiError | UsageResponse;

export const GetUsageResponse$zodSchema: z.ZodType<GetUsageResponse> = z.union([
  ApiError$zodSchema,
  UsageResponse$zodSchema,
]);
